module.exports = __webpack_public_path__ + "7df6f2e3396c3c723e42ef59a6d16877.svg";